<div class="row align-center">
    <img
        routerLink="/home/user"
        src="/images/logo_name.svg"
        alt="ideastream.io Logo mit Text"
        class="logo pointer"
    />
</div>
<div class="row gap-8 align-center">
    <div class="row gap-8 align-center">
        <!-- <rr-teamheader></rr-teamheader> -->
    </div>
    <rr-usermenue [showName]="true"></rr-usermenue>
</div>
